export default __webpack_public_path__ + "static/big-salesforce-6907079b3237e5decf72861ad701ad23.png";